import { createFileRoute } from '@tanstack/react-router'
import ProjectRenameFolderModalWrapper from '../../../../../containers/project-menu/components/project-rename-folder-modal'
import { renameSearchSchema } from '../search-schemas'

export const Route = createFileRoute(
  '/_authenticated/project/_projects/rename/'
)({
  validateSearch: renameSearchSchema,
  component: ProjectRenameFolderModalWrapper
})
